import styled from 'styled-components';
import { Button } from '../Button';
import { Select } from '../Input';

export const WrapperStyled = styled.div`
  width: 650px;
  padding: 1.5rem;
`;

export const SelectStyled = styled(Select)`
  margin: 2rem 0;
`;

export const ButtonAreaStyled = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const ButtonStyled = styled(Button)`
  height: 40px;
  margin-left: 1rem;
`;
